import {
  AUTH_ERROR,
  INVALID_PARAMETER,
  INVALID_REQUEST,
  NOT_FOUND,
  RATE_LIMIT_EXCEEDED,
  REQUEST_TIMEOUT,
  SERVER_ERROR,
  SERVICE_ERROR,
  UNKNOWN_ERROR
} from '../constants/api-error-enums';
/**
 * convert Api Error with new spec if external SRC is supported
 * @param {object} parsedData parsed API error
 * @return {object} errorResponse with new Spec
 *
 * See https://visawiki.trusted.visa.com/pages/viewpage.action?pageId=297137004 for more information
 *
 * TODO: add more specific error checking logic once each API/case error response is available 11/2018
 * General:
 *      1. UNKNOWN_ERROR (done)
 *      2. REQUEST_TIMEOUT (done)
 *      3. SERVER_ERROR (done)
 *      4. INVALID_PARAMETER (done)
 *      5. INVALID_REQUEST (done)
 *      6. AUTH_ERROR (done)
 *      7. NOT_FOUND (done)
 *      8. RATE_LIMIT_EXCEEDED (done)
 *      9. SERVICE_ERROR (done)
 */

const convertApiError = response => {
  // edge case start
  const { errorCode, httpStatus } = response;
  // some parameter in request is not valid or is not verified
  if (httpStatus === 400) {
    return INVALID_PARAMETER;
  }
  // CVV or OTP check failed; other risk check failures
  if (httpStatus === 401) {
    return AUTH_ERROR;
  }
  // something is not found (intentId, user, paymentInstrument)
  if (httpStatus === 404) {
    return NOT_FOUND;
  }
  if (httpStatus === 408) {
    return REQUEST_TIMEOUT;
  }
  // duplicate updateIntent request but with a different addressId or paymentInstrumetnId
  if (httpStatus === 409) {
    return INVALID_REQUEST;
  }
  // Risk / DFM denial due to exceeding number of requests in a certain time period
  if (httpStatus === 423 || httpStatus === 429) {
    return RATE_LIMIT_EXCEEDED;
  }
  if (httpStatus === 503) {
    return SERVICE_ERROR;
  }
  // service cannot be called; unable to retrieve intent/user/card/merchant info, etc.; data-transformation or other error
  if (httpStatus === 500) {
    return SERVER_ERROR;
  }
  // move to lowest prority based on charles proxy testing
  if (errorCode === 'VCO_001') {
    return UNKNOWN_ERROR;
  }
  // general error end
  return UNKNOWN_ERROR;
};

export default convertApiError;
